import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import AlternateEmailOutlinedIcon from "@mui/icons-material/AlternateEmailOutlined";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";

const contactHighlights = [
  {
    icon: <LocalPhoneOutlinedIcon />,
    title: "Јавете ни се",
    description: "За нарачки, сервис и брзи информации.",
    action: "076 810 012",
    href: "tel:+38976810012",
  },
  {
    icon: <AlternateEmailOutlinedIcon />,
    title: "Пишете ни",
    description: "За прашања околу производи и достапност. Контактирајте не на маил или на нашите социјални мрежи",
    action: "buzzmobiledooel@gmail.com",
    href: "mailto:buzzmobiledooel@gmail.com",
  },
  {
    icon: <FmdGoodOutlinedIcon />,
    title: "Посетете не",
    description: "ул. Ленинова бр. 90, Струмица",
    action: "Отвори мапа",
    href: "https://maps.google.com/?q=Buzz+Mobile+Store+%26+Repair+Shop+Strumica",
  },
];

function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    document.title = "Buzz Mobile - Контакт";
  }, []);

  return (
    <div className="contact-page">
      <div className="container contact-page__content">
        <section className="contact-hero">
          <div className="contact-hero__copy">
            <span className="contact-hero__eyebrow">BuzzMobile контакт</span>
            <h1>Контактирајте не за мобилни телефони, додатоци и сервис.</h1>

            <div className="contact-hero__meta">
              <div className="contact-hero__meta-card">
                <strong>Работно време</strong>
                <span>Пон - Саб | 09:00 - 19:00</span>
              </div>
              <div className="contact-hero__meta-card">
                <strong>Локација</strong>
                <span>Струмица, ул. Ленинова бр. 90</span>
              </div>
            </div>
          </div>

          <div className="contact-hero__aside">
            <div className="contact-hero__aside-card">
              <span className="contact-hero__badge">Директен контакт</span>
              <a href="tel:+38976810012">076 810 012</a>
              <p>За продажба, сервис и прашања околу достапност.</p>
            </div>
            <div className="contact-hero__aside-card contact-hero__aside-card--dark">
              <span className="contact-hero__badge">Следете не</span>
              <div className="contact-socials">
                <a
                  href="https://www.facebook.com/buzzmobilemk/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Buzz Mobile Facebook"
                >
                  <FacebookIcon />
                </a>
                <a
                  href="https://www.instagram.com/buzzmobile.mk"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Buzz Mobile Instagram"
                >
                  <InstagramIcon />
                </a>
                <a
                  href="https://www.tiktok.com/@buzzmobilestore"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Buzz Mobile TikTok"
                >
                  <svg
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 30 30"
                    width="24px"
                    height="24px"
                  >
                    <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.104,4,24,4z M22.689,13.474 c-0.13,0.012-0.261,0.02-0.393,0.02c-1.495,0-2.809-0.768-3.574-1.931c0,3.049,0,6.519,0,6.577c0,2.685-2.177,4.861-4.861,4.861 C11.177,23,9,20.823,9,18.139c0-2.685,2.177-4.861,4.861-4.861c0.102,0,0.201,0.009,0.3,0.015v2.396c-0.1-0.012-0.197-0.03-0.3-0.03 c-1.37,0-2.481,1.111-2.481,2.481s1.11,2.481,2.481,2.481c1.371,0,2.581-1.08,2.581-2.45c0-0.055,0.024-11.17,0.024-11.17h2.289 c0.215,2.047,1.868,3.663,3.934,3.811V13.474z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="contact-highlights">
          {contactHighlights.map((item) =>
            item.href.startsWith("http") ? (
              <a
                key={item.title}
                className="contact-highlight-card"
                href={item.href}
                target="_blank"
                rel="noreferrer"
              >
                <span className="contact-highlight-card__icon">
                  {item.icon}
                </span>
                <strong>{item.title}</strong>
                <p>{item.description}</p>
                <span className="contact-highlight-card__action">
                  {item.action}
                </span>
              </a>
            ) : (
              <a
                key={item.title}
                className="contact-highlight-card"
                href={item.href}
              >
                <span className="contact-highlight-card__icon">
                  {item.icon}
                </span>
                <strong>{item.title}</strong>
                <p>{item.description}</p>
                <span className="contact-highlight-card__action">
                  {item.action}
                </span>
              </a>
            ),
          )}
        </section>

        <section className="contact-layout">
          <div className="contact-panel contact-panel--form">
            <div className="contact-panel__heading">
              <span className="contact-section__eyebrow">Испратете порака</span>
              <h2>Контактирајте го нашиот тим</h2>
              <p>
                Пополнете ја формата и ќе ви вратиме одговор со информации,
                достапност или следни чекори.
              </p>
            </div>

            <form
              action="https://formspree.io/f/mzboawdv"
              method="POST"
              className="contact-form"
            >
              <TextField
                label="Име и презиме"
                variant="outlined"
                className="order__input"
                value={name}
                name="name"
                type="text"
                required
                fullWidth
                onChange={(event) => setName(event.target.value)}
              />
              <TextField
                label="Е-пошта"
                variant="outlined"
                className="order__input"
                value={email}
                type="email"
                name="email"
                required
                fullWidth
                onChange={(event) => setEmail(event.target.value)}
              />
              <TextField
                label="Телефонски број"
                variant="outlined"
                className="order__input"
                value={phone}
                type="tel"
                name="phone"
                required
                fullWidth
                onChange={(event) => setPhone(event.target.value)}
              />
              <TextField
                label="Вашата порака"
                variant="outlined"
                className="order__input"
                value={message}
                multiline
                name="message"
                rows={5}
                required
                fullWidth
                onChange={(event) => setMessage(event.target.value)}
              />

              <div className="contact-form__footer">
                <div className="contact-form__note">
                  <AccessTimeOutlinedIcon />
                  <span>Најчесто одговараме во текот на истиот ден.</span>
                </div>
                <Button
                  type="submit"
                  variant="contained"
                  className="contact-form__submit"
                >
                  Испрати порака
                </Button>
              </div>
            </form>
          </div>

          <div className="contact-panel contact-panel--map">
            <div className="contact-panel__heading">
              <span className="contact-section__eyebrow">Локација</span>
              <h2>Посетете не во продавница.</h2>
              <p>
                Ако сакате побрз договор или директен увид во производите, ве
                очекуваме во Buzz Mobile & Repair Shop.
              </p>
            </div>

            <div className="contact-map-card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11963.260070342594!2d22.6406868!3d41.4432353!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x111235751fddb00a!2sBuzz%20Mobile%20-%20Store%20%26%20Repair%20Shop!5e0!3m2!1sen!2smk!4v1649079446682!5m2!1sen!2smk"
                width="100%"
                height="100%"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
                allowFullScreen=""
                loading="lazy"
                title="buzz mobile location"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            <div className="contact-visit-card">
              <div>
                <strong>Buzz Mobile</strong>
                <p>ул. Ленинова бр. 90, Струмица</p>
              </div>
              <a
                href="https://maps.google.com/?q=Buzz+Mobile+Store+%26+Repair+Shop+Strumica"
                target="_blank"
                rel="noopener noreferrer"
              >
                Отвори насока
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Contact;
